document.addEventListener('DOMContentLoaded', function() {
  // window.addEventListener("change", function () {alert(2);
$('.customm_product .disabled.customhide').prop("disabled", true);
  document.getElementsByClassName('customhide')[0].style.display = 'none'; 
  $('.customm_product .disabled.customhide').prop("disabled", true); // for safari
$('.customm_product .disabled.customhide').hide();
    });
document.addEventListener("DOMContentLoaded", function () {
  $('.quick-add__submit').click(function(){
    setTimeout(function(){
  document.querySelector('.customhide').style.display = 'none';
      }, 1000);
  })
});

